"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var calculateTop = function calculateTop(elem, popup, placement, popupContainer) {
  var elemCoords = elem.getBoundingClientRect();
  var popupCoords = popup.getBoundingClientRect();
  var isContainerBody = popupContainer.tagName === 'BODY';
  var thresholdTop = 0;

  if (!isContainerBody) {
    thresholdTop = popupContainer.getBoundingClientRect().top + document.documentElement.scrollTop;
  }

  var scrollTop = window.scrollY - thresholdTop;
  var top;

  switch (placement) {
    case 'top':
    case 'topRight':
    case 'topLeft':
      top = elemCoords.top - popupCoords.height;
      break;

    case 'bottom':
    case 'bottomLeft':
    case 'bottomRight':
      top = elemCoords.height + elemCoords.top;
      break;

    case 'leftTop':
    case 'rightTop':
      top = elemCoords.top;
      break;

    case 'left':
    case 'right':
      top = elemCoords.top + (elemCoords.height / 2 - popupCoords.height / 2);
      break;

    case 'leftBottom':
    case 'rightBottom':
      top = elemCoords.top + elemCoords.height - popupCoords.height;
      break;

    default:
      if (elemCoords.top - popupCoords.height > 0) {
        top = elemCoords.top - popupCoords.height;
      } else {
        top = elemCoords.height + elemCoords.top;
      }

  }

  return top + scrollTop;
};

var _default = calculateTop;
exports.default = _default;